import { useEffect, useState } from 'react';

export const DEFAULT_BREAKPOINTS = {
  small: 540,
  medium: 768,
  large: 1024,
};

const usePremiumImgBreakpoints = () => {
  const [imgSrc, setImgSrc] = useState('img_default');

  useEffect(
    () => {
      let size = Object.keys(DEFAULT_BREAKPOINTS)[0];
      const keys = Object.keys(DEFAULT_BREAKPOINTS);
      for (const key of keys) {
        if (window.innerWidth > DEFAULT_BREAKPOINTS[key]) {
          size = key;
        }
      }
      setImgSrc(`image_${size}`);
    },
    [window.innerWidth],
  );

  return {
    imgSrc,
  };
};

export default usePremiumImgBreakpoints;
